import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-toco-reset",
  "use": "icon-toco-reset-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"icon-toco-reset\"><title>宫缩</title><path d=\"M25,43.5c-6.16,0-11-7.83-11-17.84S18.84,7.82,25,7.82s11,7.84,11,17.84S31.16,43.5,25,43.5Zm0-32.68c-4.33,0-8,6.8-8,14.84S20.67,40.5,25,40.5s8-6.79,8-14.84S29.33,10.82,25,10.82Z\" /><path d=\"M15.82,25.36,6.4,12.65a.5.5,0,0,0-.9.3V38.38a.5.5,0,0,0,.9.29L15.82,26A.51.51,0,0,0,15.82,25.36Z\" /><path d=\"M34.18,26,43.6,38.67a.5.5,0,0,0,.9-.29V13a.5.5,0,0,0-.9-.3L34.18,25.36A.51.51,0,0,0,34.18,26Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol